export default {
  data() {
    return {
      usuario: null
    };
  },
  methods: {
    async getUsuario() {
      const { data } = await this.$http.get("/autenticacao/dados");
      this.usuario = data;
    },
    async setUsuario(usuario) {
      this.usuario = await usuario;
    }
  }
};
